export const currencyReqData = {
  "currencyName": "",
  "currencyCode": "",
  "exchangeRateInNaira": "",
  "symbol": "",
  useIntermediateUSDCurrency: true,
  oneUSDToCurrency: "",
  oneUSDToNaira: "",
}

export const currencyData = {
  "id": null,
  "currencyName": null,
  "currencyCode": null,
  "exchangeRateInNaira": null,
  "symbol": null,
  "status": null,
  "updatedDate": null,
  "createdDate": null,
}